module.exports = __webpack_public_path__ + "img/image 5.72fe73ab.png";